import React, { useContext, useEffect, useState } from 'react';
import useScreenHistory from '../hooks/useScreenHistory';
import { DataLayerEventContext } from '../contexts/dataLayerEventContext';
import HomeScreen from '../components/25-sms-lm-ssl/home-screen';
import ErrorScreen from '../components/lm-d-s/errorScreen';
import { ScreensContext } from '../contexts/screensContext';

const SmsLmSsl = () => {
  const { screenNumber, setScreenNumber } = useScreenHistory({
    initialScreen: 0
  });
  const [isDisplayedAll, setIsDisplayedAll] = useState(false);
  const [endSessionType, setEndSessionType] = useState('SESSION_END');

  const { init, sendEvent } = useContext(DataLayerEventContext);

  useEffect(() => {
    init('25-sms-lm-ssl');
    sendEvent('age_verification_without');
    sessionStorage.setItem('unsubscription_source', '25-sms-lm-ssl');
  }, [init]);

  const getScreen = (number, cb) => {
    switch (number) {
      case 0: {
        return <HomeScreen setScreenNumber={cb} />;
      }
      default: {
        return <ErrorScreen setScreenNumber={cb} />;
      }
    }
  };

  return (
    <ScreensContext.Provider
      value={{
        endSessionType,
        setEndSessionType,
        isDisplayedAll,
        setIsDisplayedAll
      }}
    >
      {getScreen(screenNumber, setScreenNumber)}
    </ScreensContext.Provider>
  );
};

export default SmsLmSsl;
